// extracted by mini-css-extract-plugin
module.exports = {"titleRow":"bundleTitleRow_titleRow__3inuX","title":"bundleTitleRow_title__2Hktx","subtitle":"bundleTitleRow_subtitle__2J796"};